import { Application } from "@hotwired/stimulus"
import { registerControllers } from "stimulus-vite-helpers";

import { appsignal } from "./utils/appsignal";
import { installErrorHandler } from "@appsignal/stimulus";

import.meta.glob("./**/*_channel.js", { eager: true });

const application = Application.start()
installErrorHandler(appsignal, application);
const controllers = import.meta.glob("./controllers/*_controller.js", { eager: true });

registerControllers(application, controllers);
